export default "__VITE_ASSET__CztUvCFp__"